import { render, staticRenderFns } from "./WineryPictures.vue?vue&type=template&id=b22a693c&"
import script from "./WineryPictures.vue?vue&type=script&lang=js&"
export * from "./WineryPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports